import { TFunction } from 'i18next'
import z from 'zod'

import { DEFAULT_LIMIT } from '@/components/ui/pagination/pagination.constants'
import { TableColumn } from '@/components/ui/table'
import { EMPTY_VALUE } from '@/constants'
import { VisitorParkingSessionModel } from '@/models'
import { formatDateOnly, formatInternationalNumber, formatPrice, formatTimeOnly } from '@/utils'

export const getVisitorsParkingColumns = (
  t: TFunction<['parking-management']>,
): TableColumn<VisitorParkingSessionModel>[] => [
  {
    id: 'ticketNumber',
    render: (session) => session.ticketNumber,
    title: t('parking-management:visitorsParking.columns.ticketNumber'),
  },
  {
    id: 'licensePlate',
    render: (session) => session.licensePlate,
    title: t('parking-management:visitorsParking.columns.licensePlate'),
  },
  {
    id: 'name',
    render: (session) => session.name,
    title: t('parking-management:visitorsParking.columns.name'),
    width: '18rem',
  },
  {
    id: 'email',
    render: (session) => session.email,
    title: t('parking-management:visitorsParking.columns.email'),
    width: '22.5rem',
  },
  {
    id: 'phoneNumber',
    render: (session) => formatInternationalNumber(session.phoneNumber),
    title: t('parking-management:visitorsParking.columns.phoneNumber'),
  },
  {
    id: 'checkIn',
    render: (session) =>
      session.checkIn
        ? `${formatDateOnly(session.checkIn)}\n${formatTimeOnly(session.checkIn)}`
        : EMPTY_VALUE,
    title: t('parking-management:visitorsParking.columns.checkIn'),
  },
  {
    id: 'checkOut',
    render: (session) =>
      session.checkOut
        ? `${formatDateOnly(session.checkOut)}\n${formatTimeOnly(session.checkOut)}`
        : EMPTY_VALUE,
    title: t('parking-management:visitorsParking.columns.checkOut'),
  },
  {
    id: 'totalPaid',
    render: (session) => formatPrice(session.totalPaid, { zeroPrice: true }),
    title: t('parking-management:visitorsParking.columns.totalPaid'),
  },
]

export const visitorParkingQueryFiltersSchema = z.object({
  fromDate: z.coerce.number().optional(),
  limit: z.coerce.number().optional(),
  search: z.coerce.string().optional(),
  skip: z.coerce.number().optional(),
  toDate: z.coerce.number().optional(),
})

export const visitorParkingInitialFilters: z.infer<typeof visitorParkingQueryFiltersSchema> = {
  fromDate: undefined,
  limit: DEFAULT_LIMIT,
  search: '',
  skip: 0,
  toDate: undefined,
}
